import React from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import PlaylistIntro from '../chapter3/playlist_intro';
import PlaylistNavi from '../chapter3/playlist_navi';
import PlaylistSongIntro from '../chapter3/playlist_song_intro';
import PlaylistTeaser from '../chapter3/playlist_teaser';

import VideoDOM_without_blob from '../videoDOM_without_blob';

import Iconset from '../icons';

import poster from '../../images/song_poster.jpg';

import "../../styles/chapter3/playlist.scss";

class Playlist extends React.Component{

	constructor(props){
		super(props);

		this.state = {
			showPlaylistIntro : true,
			innerSong : -1,
		}		
	}

	goToSong(index){
		this.props.changeSongToIndex(index);
		
	}

	render(){
		return (<div className="playlist">	
			<ReactCSSTransitionGroup
				component= "div"
				className="absolute playlist-inner-holder"
				transitionName="fade"
				transitionEnterTimeout={500}
				transitionLeaveTimeout={300}>

			{/* INTRO */}
			{this.props.currentInnerChapter == 1 && 
				<PlaylistIntro 
					key="playlistIntro"
					ref={(video)=>{this.videoRef = video;}}
					timeupdate={this.props.timeupdate}
					isWaiting={this.props.isWaiting}
					ended={this.props.ended}
					isPlaying={this.props.isPlaying}
					play={this.props.play}
					pause={this.props.pause}
					currentVideoTimePercentage = {this.props.currentVideoTimePercentage}
					poster={""} />
			}

			{/* PLAYLIST */}
					{this.props.currentInnerChapter == 2 && 
						<div key="playlist" className="absolute playlist-inner">
							{this.props.showMobileTrigger &&
								<div className="mobile-trigger">
									<div className="mobile-trigger-inner">
										{(this.props.currentSong > 1) && <p>Next track:</p> }
										<button className="mobile-trigger-button" onClick={this.props.hideMobileTrigger}>{this.props.songs[this.props.currentSong].title} <span className="mobile-trigger-icon"><Iconset.playtrigger /></span></button>
									</div>
								</div>
							}
							{!this.props.showSongTeaser && 
								<PlaylistNavi 
									songs={this.props.songs} 
									index={this.props.currentSong}
									naviOpen={this.props.songNaviOpen}
									showSongIntro = {this.props.showSongIntro}
									toggleNavi={(bool)=>this.props.toggleNavi(bool)}
									changeSongToIndex={(index)=>this.props.changeSongToIndex(index)}/>
							}

							<ReactCSSTransitionGroup
								component= "div"
								className="absolute inner-note-intro"
							  transitionName="fade"
							  transitionEnterTimeout={500}
							  transitionLeaveTimeout={300}>
								{/* INTRO */}
							  	{this.props.showSongIntro&& 
										<PlaylistSongIntro 
											key="intro"
											headline={this.props.songs[this.props.currentSong].title}
											index={this.props.currentSong} />
									}
								{/* TEASER */}
									{this.props.showSongTeaser &&
										<PlaylistTeaser 
											key="showSongTeaser"
											songs={this.props.songs} 
											index={this.props.currentSong + 1} />
									}
								</ReactCSSTransitionGroup>
							
							<ReactCSSTransitionGroup
								component= "div"
								className="absolute playlist-video"
							  transitionName="fade"
							  transitionEnterTimeout={500}
							  transitionLeaveTimeout={300}>

									<VideoDOM_without_blob 
										key={this.props.currentSong}
										ref={(video)=>{this.videoRef = video;}}
										src={_assets.root + "/video/chapter3/"+ _assets.videoSize + "/" + this.props.songs[this.props.currentSong].url}
										timeupdate={this.props.timeupdate}
										isWaiting={this.props.isWaiting}
										ended={this.props.ended}
										isPlaying={this.props.isPlaying}
										play={this.props.play}
										pause={this.props.pause}
										poster={poster} />
							</ReactCSSTransitionGroup>
							
							
			</div>
		}
		</ReactCSSTransitionGroup>


		</div>);
	}
}

export default Playlist;


// WEBPACK FOOTER //
// ./src/scripts/chapter3/playlist.js